import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { CartContextStart } from "../Context/CartContext";
import logo from "../images/logo.png";
// import cartImg from "../images/ProductImages/armchair-400x400.jpg";
import SlideInCartItem from "./SlideInCartItem";

export default function NavBar() {

  const { cartItems, setCartItems } = useContext(CartContextStart);
  const [subTotal, setSubTotal] = useState();

  const bodyOverlay = useRef("");
  const slideInCart = useRef("");

  let openCart = () => {
    bodyOverlay.current.classList.add("body-overlay-active");
    slideInCart.current.classList.add("slide-in-cart-active");
  }

  let closeCart = () => {
    bodyOverlay.current.classList.remove("body-overlay-active");
    slideInCart.current.classList.remove("slide-in-cart-active");
  }

  useEffect(() => {
    setSubTotal(
      cartItems.reduce((acc, currentItem) => {
        return acc + (currentItem.getProductData.pPrice * currentItem.itemQuantity);
      }, 0)
    )
  }, [cartItems]);


  return (
    <>
      {/* Navigation Bar Start */}
      <nav className="navbar navbar-expand-lg position-relative">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={logo} className="logo" alt="Furniture-Store-Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-3 mt-4 mb-2 my-lg-0 gap-2 gap-lg-3">
              <li className="nav-item">
                <Link to="all-products" className="nav-link" href="#">
                  All Products
                </Link>
              </li>
              <li className="nav-item">
                <Link to="sofa" className="nav-link" href="#">
                  Sofa
                </Link>
              </li>
              <li className="nav-item">
                <Link to="chair" className="nav-link" href="#">
                  Chair
                </Link>
              </li>
              <li className="nav-item">
                <Link to="table" className="nav-link" href="#">
                  Table
                </Link>
              </li>
            </ul>

            <ul className="navbar-nav ms-3 ms-lg-auto mb-2 mb-lg-0 gap-2 gap-lg-3 me-4 pe-3">
              <li className="nav-item">
                <Link to="about-us" className="nav-link" href="#">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link to="my-account" className="nav-link" href="#">
                  My Account
                </Link>
              </li>
            </ul>

            <div onClick={openCart} className="m-0 p-0 d-flex ms-3 mt-4 m-lg-0 gap-3 cart-and-total">
              <span className="fw-semibold">£{subTotal ? subTotal : "0.00"}</span>
              <span className="position-relative d-none d-lg-inline">
                <i className="fa-solid fa-cart-shopping"></i>
                <div className="cart-counter fw-semibold d-flex justify-content-center align-items-center">
                  <p className="m-0 p-0">{cartItems.length}</p>
                </div>
              </span>
            </div>
          </div>
        </div>

        {/* Cart Icon and details for mobile */}
        <div onClick={openCart} className="m-0 p-0 d-flex ms-3 m-lg-0 d-lg-none cart-and-total cart-and-total-mobile">
          <span className="position-relative">
            <i className="fa-solid fa-cart-shopping"></i>
            <div className="cart-counter fw-semibold d-flex justify-content-center align-items-center">
              <p className="m-0 p-0">{cartItems.length}</p>
            </div>
          </span>
        </div>
      </nav>
      {/* Navigation Bar End */}

      {/* Complete page Overlay Start */}
      <div ref={bodyOverlay} className="body-overlay"></div>
      {/* Complete page Overlay End */}

      {/* Slide-In Cart Start */}
      <div ref={slideInCart} className="slide-in-cart col-lg-4 col-md-6 col-sm-8 col-12">
        <div className="slide-in-cart-header d-flex justify-content-between">
          <p className="p-0 m-0">Shopping Cart</p>
          <p className="p-0 m-0">
            <i onClick={closeCart} className="fa-solid fa-x"></i>
          </p>
        </div>
        <div className="slide-in-cart-body">
          {
            cartItems.map((singleItem) => {
              return (
                <SlideInCartItem
                  key={singleItem.getProductData.pid}
                  cartItemImg={singleItem.getProductData.pImg}
                  cartItemTitle={singleItem.getProductData.pTitle}
                  cartItemPrice={singleItem.getProductData.pPrice}
                  cartItemQuantity={singleItem.itemQuantity}
                  cartItemProductId={singleItem.getProductData.pid}
                />
              )
            })
          }
        </div>
        <div className="slide-in-cart-footer">
          <div className="cart-subtotal d-flex justify-content-between align-items-center">
            <p className="m-0 p-0 subtotal-heading">Subtotal:</p>
            <p className="m-0 p-0 subtotal-price">£{subTotal}</p>
          </div>
          <div className="footer-btns">
            <button onClick={() => { setCartItems([]) }} className="btn mb-3">Clear Cart</button>
            <button className="btn">Checkout</button>
          </div>
        </div>
      </div>
      {/* Slide-In Cart End */}

      <Outlet />
    </>
  );
}
